import React, { Component } from 'react';
import { Range as RcRange } from 'rc-slider';
import handle from './handle';

import PropTypes from 'prop-types';

export default class Range extends Component {
  render() {
    const {
      defaultValue,
      value,
      pushable,
      onChange,
      marks,
      step,
      unit,
      hideStepLabel,
      style,
      trackStyle,
      railStyle,
      activeDotStyle,
      handleStyle,
      draggableTrack,
      onAfterChange,
      min,
      max,
      ...others
    } = this.props;
    return (
      <div className="slider-wrapper" style={style}>
        <RcRange
          trackStyle={trackStyle}
          railStyle={railStyle}
          dotStyle={activeDotStyle}
          marks={marks}
          handle={props =>
            handle(props, { unit: unit, hideStepLabel: hideStepLabel })
          }
          onChange={onChange}
          onAfterChange={onAfterChange}
          defaultValue={defaultValue}
          allowCross={false}
          pushable={pushable}
          value={value}
          step={step}
          max={max}
          min={min}
          draggableTrack={draggableTrack}
          handleStyle={handleStyle}
          {...others}
        />
      </div>
    );
  }
}

Range.defaultProps = {
  defaultValue: [0, 0],
  pushable: 10,
  unit: '%',
  step: 1,
  hideStepLabel: false,
  draggableTrack: false,
  style: {},
  trackStyle: [
    { backgroundColor: '#3a7eea', height: 3 },
    { backgroundColor: '#3a7eea', height: 3 }
  ],
  railStyle: { backgroundColor: '#d6dce7', height: 3 },
  activeDotStyle: { borderColor: '#3a7eea' },
  handleStyle: [
    {
      borderColor: '#3a7eea',
      height: 14,
      width: 14,
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0)'
    },
    {
      borderColor: '#3a7eea',
      height: 14,
      width: 14,
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0)'
    }
  ],
  onChange: () => {}
};

Range.propTypes = {
  defaultValue: PropTypes.arrayOf(PropTypes.number),
  value: PropTypes.arrayOf(PropTypes.number),
  unit: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hideStepLabel: PropTypes.bool.isRequired,
  marks: PropTypes.object,
  step: PropTypes.number,
  style: PropTypes.object,
  pushable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  trackStyle: PropTypes.arrayOf(PropTypes.object),
  railStyle: PropTypes.object,
  activeDotStyle: PropTypes.object,
  handleStyle: PropTypes.arrayOf(PropTypes.object)
};
